import { Component, ElementRef, OnInit, ViewChild, } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { OtherService } from 'src/app/services/other.service';

import { MatDialog } from '@angular/material/dialog';

import { AccountService } from 'src/app/services/account.service';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { DatePipe } from '@angular/common';

import { AdsInfiniteScrollService } from '../business-main-infinite-scroll/service/ads-infinite-scroll.service';

import { ajax } from 'rxjs/ajax';

import { environment } from 'src/environments/environment';

declare var bootstrap: any;
@Component({

  selector: 'app-news',

  templateUrl: './news.component.html',

  styleUrls: ['./news.component.css'],

})

export class NewsComponent implements OnInit {

  Info: any;

  news: any = [];

  newsDetail: any;

  modeRead: boolean = false;

  bDataEnded: boolean = false;

  bScrollLoading: boolean = false;

  isResultLoading: boolean = false;

  bUpButton: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.otherService.getLocalStorage().Id || 0),

    strSession: new FormControl(this.otherService.getLocalStorage().session || ''),

    iPage: new FormControl('-1'),

    iTotal: new FormControl('-1'),

    tiType: new FormControl('-1'),

  })

  @ViewChild('point_1', { static: false }) private my_point_1: ElementRef;

  constructor(

    private otherService: OtherService,

    private toastr: ToastrService,

    private dialog: MatDialog,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private router: Router,

    private route: ActivatedRoute,

    private datePipe: DatePipe,

    private FormBuilder: FormBuilder,

    private _InfiniteScrollService: AdsInfiniteScrollService,

    private _otherService: OtherService


  ) { }

  ngOnInit(): void {

    this.route?.url?.subscribe((segment) => {

      this.modeRead = segment[1]?.path ? true : false;

      if (this.modeRead) {

        let iNews = segment[1]?.path

        this.accountService.TaxiLon_News_Info(iNews).subscribe((response) => {

          let res = JSON.parse(response.toString());

          this.newsDetail = res[0];

          this.otherService.setTitle(`امدادران | ${this.newsDetail.strTitle}`)

        });

      }

      else {

        this.accountService.TaxiLon_News(this.otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((response) => {

          this.news = JSON.parse(response.toString());

          this.mdl_Search.controls['iTotal'].setValue(this.news.length ? this.news[0].iTotal : '0');

          this._InfiniteScrollService.update_DataStatus(false);

          this.bDataEnded = false;

        });

        // listen to user scroll activity

        this._InfiniteScrollService.isScrollToBottom$.subscribe((isScrollBottom: boolean) => {

          if (isScrollBottom && !this.bDataEnded && this.news.length && !this.isResultLoading) {

            this.loadMoreData();

          }

        });

        this._InfiniteScrollService.isDataEnded$.subscribe((isEnded: boolean) => {

          if (isEnded) {

            this.bScrollLoading = false;

            this.bDataEnded = true;

          }

        });

      }

    });

  }

  ngOnDestroy() {

    this.otherService.setTitle('');

    this._InfiniteScrollService.update_DataStatus(false);

  }

  openDetail(item: any, index: number) {

    window.open(`news/${item.iNews}`, '_blank');

  }

  subString_Title(text: string, limit?: number) {

    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';


    return text;
  }

  loadMoreData() {

    if (this.news.length == this.mdl_Search.get('iTotal')?.value) {

      this._InfiniteScrollService.update_DataStatus(true);
    }

    else {

      this.bScrollLoading = true;

      setTimeout(() => {

        this.mdl_Search.get('iPage')?.setValue(this.news[this.news.length - 1].iPage);

        this.sendDataToApi();

      }, 600);

    }

  }

  sendDataToApi() {

    this.isResultLoading = true;

    ajax.post(environment.taxiUrl + `TaxilLon_News_List?iPage=${this.mdl_Search.value.iPage}`, this._otherService.stringNumberToNumber(this.mdl_Search.value), {

      'Content-Type': 'application/json',

    }).subscribe({

      next: (value: any) => {

        this.isResultLoading = false;

        this.bScrollLoading = false;

        let res = JSON.parse(value.response);

        if (res.bError) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this.accountService.toastSwal('error', res.strError);

        }

        if (!res.length) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this.accountService.toastSwal('error', 'موردی یافت نشد');

        }

        this.news = this.news.concat(res);

        this.mdl_Search.get('iTotal')?.setValue(this.news[0].iTotal);

        // if "iPage" is Equal to 0 , Stop gathering data

        if (res[res.length - 1].iPage == 0) {

          this._InfiniteScrollService.update_DataStatus(true);

        }

      },

      error: (err) => {

        this.accountService.toastSwal('error', 'لطفا وضعیت اتصال اینترنت خود را بررسی کنید');

        this.isResultLoading = false;

        this._InfiniteScrollService.update_DataStatus(true);

      },

    });

  }

  gotoTop() {

    this.my_point_1.nativeElement.scrollIntoView({

      behavior: 'smooth',

    });

    setTimeout(() => {

      this.bUpButton = false;

    }, 1000);

  }

}
